// @flow
import queryString from 'query-string';

const getThirdPartyLoginUrl = ({
  provider,
  redirectTo,
  inviteId,
  savedListing,
  subscribedSubsite
}: {
  provider: 'facebook' | 'google',
  redirectTo: ?string,
  inviteId?: ?string,
  savedListing: ?Object,
  subscribedSubsite: ?string
}) => {
  const queryParams = {};
  queryParams.provider = provider;
  if (redirectTo) {
    queryParams.to = redirectTo;
  }
  if (inviteId) {
    queryParams.invite = inviteId;
  }
  if (savedListing) {
    queryParams['saved-listing'] = JSON.stringify(savedListing);
  }
  if (subscribedSubsite) {
    queryParams['subscribe-subsite'] = subscribedSubsite;
  }
  return `/third-party-login?${queryString.stringify(queryParams)}`;
};

export default getThirdPartyLoginUrl;
